import { Module } from '../../../../../shared/objects/auth/module';
import { Country } from '../../../../../shared/objects/order/country';

export class Carrier {
  public carrierId: number;
  public company: string;
  public contactPerson: string;
  public email: string;
  public street: string;
  public city: string;
  public country: string;
  public zipCode: string;
  public phoneNumber: string;
  public mobilePhoneNumber: string;
  public faxNumber: string;
  public website: string;
  public vatNumber: string;
  public chamberOfCommerce: string;
  public fmsCarrierId: string;
  public mustConfirmOrder: boolean;
  public currencyId: number;
  public fmsCarrierCode: string;
  public blocked: boolean;
  public equipmentType: number;
  public countries: Country[];
  public modules: Module[];
}
